import { Injectable, Type } from '@angular/core';
import { DropdownComponent } from './dropdown/dropdown.component';
import { FilterDateRangePickerComponent } from './filter-date-range-picker/filter-date-range-picker.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import {
  DeviceTypeCRUDInterface,
  FilterClass,
  FilterClassInterface, FilterDataObjectTypes,
  KeyValueDropdownInterface,
  UsersCRUDInterface
} from './filter.class';
import { IotDeviceManagementPortalAppState } from '../../../store/iotDeviceManagementPortalApp.reducer';
import { Store } from '@ngrx/store';
import { HttpOptionInterface } from '../../../store/filter/filter.model';
import { take } from 'rxjs/operators';
import { ResetUserStore, StartLoadFilterUsers } from '../../../store/filter/user/user.actions';
import { BehaviorSubject } from 'rxjs';
import { StartLoadFilterDeviceTypes } from '../../../store/filter/device-type/device-type.actions';
import * as DeviceActions from '../../../store/device/device.actions';

export enum ObjectNameProps {
  title = 'title',
  translateTitle = 'translatedTitle',
  productIdDescriptionInfo = 'productIdDescriptionInfo',
  shiftName = 'name',
  departmentName = 'lineType',
  observationName = 'name',
  username = 'username',
  equipmentName = 'equipmentName',
  activityTypeRelation = 'name',
  level = 'name',
  startOfDay = 'name',
  sensor = 'sensorIdWithType',
  productFamily = 'productFamily',
  woNumber = 'woNumber',
  task = 'title',
}

export const statusConstant = {
  active: {
    key: 1,
    entityName: 'Active',
    operator: '$notnull',
    id: 1,
  },
  inactive: {
    key: 0,
    entityName: 'Inactive',
    operator: '$notnull',
    id: 0,
  },
};

@Injectable({
  providedIn: 'root',
})
export class User extends FilterClass implements FilterClassInterface {
  public options: HttpOptionInterface = {
    page: 1,
    limit: 50,
    s: JSON.stringify({ fullName: { $ne: '' } }),
  };
  public objectNameProp: string = 'fullName';

  constructor(public store: Store<IotDeviceManagementPortalAppState>) {
    super();
  }

  public init(): void {
    this.dataSubject.next([]);

    this.subscribe = this.store.select('userFilter').subscribe((state) => {
      if (state.isLoaded && state.isLoading === false) {
        this.data = state.data;
        this.dataSubject.next(state.data);
      }
    });
  }

  public getInitialData(): UsersCRUDInterface[] {
    let data;
    this.store
      .select('userFilter')
      .pipe(take(1))
      .subscribe((state) => {
        data = state.data;
      });
    return data;
  }

  public getFilterData(options: HttpOptionInterface): void {
    this.options = { ...this.options, ...options };

    this.store.dispatch(new StartLoadFilterUsers(this.options.page, this.options.limit, this.options.filter));
  }

  public destroy(): void {
    this.store.dispatch(new ResetUserStore());
  }
}

@Injectable({
  providedIn: 'root',
})
export class Status extends FilterClass implements FilterClassInterface {
  public data: KeyValueDropdownInterface[] = [
    { key: statusConstant.inactive.key, name: statusConstant.inactive.entityName },
    { key: statusConstant.active.key, name: statusConstant.active.entityName },
  ];
  public dataSubject: BehaviorSubject<any>;

  constructor() {
    super();
    this.data.forEach((dataType) => {
      dataType.id = dataType.key;
    });
    this.dataSubject = new BehaviorSubject<object>(this.data);
  }

  public getInitialData(): KeyValueDropdownInterface[] {
    return this.data;
  }
}


@Injectable({
  providedIn: 'root',
})
export class DeviceType extends FilterClass implements FilterClassInterface {
  public options: HttpOptionInterface = {
    page: 1,
    limit: 50,
    s: JSON.stringify({ name: { $cont: '' } }),
  };
  public objectNameProp: string = 'name';

  constructor(public store: Store<IotDeviceManagementPortalAppState>) {
    super();
  }

  public init(): void {
    this.dataSubject.next([]);

    this.subscribe = this.store.select('deviceTypeFilter').subscribe((state) => {
      if (state.data.length === 0 && state.isLoaded === false && state.isLoading === false) {
        this.store.dispatch(new StartLoadFilterDeviceTypes(this.options, this.apiServer));
      }
      if (state.isLoaded && state.isLoading === false) {
        this.data = state.data;
        this.dataSubject.next(state.data);
      }
    });
  }

  public getInitialData(): DeviceTypeCRUDInterface[] {
    let data;
    this.store
      .select('deviceTypeFilter')
      .pipe(take(1))
      .subscribe((state) => {
        data = state.data;
      });
    return data;
  }

  public getFilterData(options: HttpOptionInterface): void {
    this.options = { ...this.options, ...options };

    this.store.dispatch(new StartLoadFilterDeviceTypes(this.options, this.apiServer));
  }

  public destroy(): void {
    this.store.dispatch(new ResetUserStore());
  }
}



@Injectable({
  providedIn: 'root',
})
export class Client extends FilterClass implements FilterClassInterface {
  public options: HttpOptionInterface = {
    page: 1,
    limit: 50,
    s: JSON.stringify({ name: { $cont: '' } }),
  };
  public objectNameProp: string = 'name';

  constructor(public store: Store<IotDeviceManagementPortalAppState>) {
    super();
  }

  public init(): void {
    this.dataSubject.next([]);

      (this.subscribe = this.store.select('deviceStore').subscribe((state) => {
        if (state.clients.length === 0 && state.getClientsLoaded === false && state.getClientsLoading === false) {
          this.store.dispatch(new DeviceActions.GetClients('ALL_PROD'));
        }
        if (state.getClientsLoaded && state.getClientsLoading === false && !this.data) {
          const filterData: FilterDataObjectTypes[] = [];
          for (const client of state.clients) {
            filterData.push({ id: client.client, name: client.name });
          }

          this.data = filterData;
          this.dataSubject.next(filterData);
        }
      }));
  }

  public getInitialData(): DeviceTypeCRUDInterface[] {
    let data;
    this.store
      .select('deviceStore')
      .pipe(take(1))
      .subscribe((state) => {
        if (state.getClientsLoaded && state.getClientsLoading === false) {
          const filterData: FilterDataObjectTypes[] = [];
          for (const client of state.clients) {
            filterData.push({ id: client.client, name: client.name });
          }
          data = filterData;
        }
      });
    return data;
  }

  public getFilterData(options: HttpOptionInterface): void {
    this.options = { ...this.options, ...options };

    // this.store.dispatch(new StartLoadFilterDeviceTypes(this.options, this.apiServer));
  }

  public destroy(): void {
    this.store.dispatch(new ResetUserStore());
  }
}

export type FilterableObjectTypes = Status | DeviceType | User | Client;

export type TypeFilterableObjects = Type<FilterableObjectTypes>;

export type FilterableComponents = DropdownComponent | FilterDateRangePickerComponent | SearchBoxComponent;
